import {
    FETCHED_WEBINARS,
    FETCHED_WEBINAR,
    CREATED_WEBINAR,
    UPDATED_WEBINAR,
    DELETED_WEBINAR,
    RESET_WEBINAR,
} from './types';
import update from 'immutability-helper';

const INITIAL_STATE = {
    all: [],
    webinarSearchCriteria: '',
    allByTerms: [],
    webinar: {},
    touched: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCHED_WEBINARS:
            return update(state, {
                all: {$set: action.payload.data},
            });

        case FETCHED_WEBINAR:
            return update(state, {
                webinar: {$set: action.webinar},
            });

        case CREATED_WEBINAR:
            return update(state, {
                webinar: {$set: {}},
            });

        case UPDATED_WEBINAR:
            return update(state, {
                webinar: {$set: action.webinar},
            });

        case DELETED_WEBINAR:
            let allWebinars = state.all.filter(
                (item) => item.id !== action.webinar
            );

            return update(state, {
                all: {$set: allWebinars},
            });

        case RESET_WEBINAR:
            return update(state, {
                webinar: {$set: {}},
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/webinars/reducer.js